<template>
  <v-dialog v-model="dialog" width="500" v-if="item">
    <template v-slot:activator="{ on }">
      <span v-on="on"> {{ title }} </span>
    </template>
    <v-card style="position: fixed; top: 100px; left: 20px; width: 550px">
      <v-card-title>
        <span class="headline" v-if="title">{{ title }}</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap v-if="item">
            <v-flex xs12>
              <v-select
                :items="items"
                v-model="localDocumentType"
                item-text="name"
                item-value="code"
                label="Select Type"
                outline
              ></v-select>
            </v-flex>
          </v-layout>
        </v-container>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="dialog = false">Close</v-btn>
        <v-btn color="blue darken-1" flat @click="convertDocument()"
          >Convert</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import ApiService from "@/services/api.service";
import UsersService from "@/services/users.service";

export default {
  props: ["type", "documentType", "item"],
  data: function () {
    return {
      dialog: false,
      items: [],
      title: null,
      localDocumentType: null,
      page: {
        title: "Convert Page",
        endpoint: "/ocr/convert/page/",
        types: [
          {
            code: "IMPORT_FLIGHTFILE",
            name: "IMPORT FLIGHT FILE",
          },
          {
            code: "EXPORT_FLIGHTFILE*",
            name: "EXPORT FLIGHT FILE",
          },
          {
            code: "MAWB",
            name: "MAWB",
          },
          { code: "COURIERFILE", name: "Courier" },
          { code: "RELEASENOTE", name: "RELEASE NOTE" },
          {
            code: "BULK_RELEASENOTE",
            name: "BULK RELEASE NOTE",
          },
        ],
      },
      file: {
        title: "Convert File",
        endpoint: "/ocr/convert/file/",
        types: [
          { code: "DSSFLIGHTFILE", name: "FLIGHT FILE" },
          { code: "PODFILE", name: "POD FILE" },
          { code: "COURIERFILE", name: "COURIER FILE" },
          { code: "T1EUROTRUCK", name: "T1 Euro Truck" },
        ],
      },
    };
  },
  methods: {
    async convertDocument() {
        try {
        const id = this.item.id;
        if (id) {
          await ApiService.query(this.endpoint + this.localDocumentType + '/' + id);
          UsersService.trackEvent({
            model: "DOCUMENT",
            modelId: id,
            message: 'deleted ' + this.type,
            reference: id,
            type: this.type,
          });
        }
      } catch (error) {
        // console.log("delete error", error);
      }
      this.dialog = false;
      this.$emit("completed");
    },
  },
  mounted() {
    if (this.type === "FILE") {
      this.items = this.file.types;
      this.title = this.file.title;
      this.endpoint = this.file.endpoint;
    } else {
      this.items = this.page.types;
      this.title = this.page.title;
      this.endpoint = this.page.endpoint;
    }
    this.localDocumentType = this.documentType;
  },
};
</script>
